/* unplugin-vue-components disabled */import { render } from "./RealDetail.vue?vue&type=template&id=174344c0&scoped=true"
import script from "./RealDetail.vue?vue&type=script&lang=js"
export * from "./RealDetail.vue?vue&type=script&lang=js"

import "./RealDetail.vue?vue&type=style&index=0&id=174344c0&lang=less&scoped=true"
import "./RealDetail.vue?vue&type=style&index=1&id=174344c0&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174344c0"]])

export default __exports__